import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import GroupLinkView from "./GroupLinkView";

function GroupLink(props) {
  const [searchParams] = useSearchParams();
  const [guid, setGuid] = useState(searchParams.get("guid") || "");
  const [name, setName] = useState(searchParams.get("name") || "");
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setGuid(params.get("guid") || "");
    setName(params.get("name") || "");
  }, [window.location.search]);
  if (guid && name) {
    return <GroupLinkView guid={guid} name={name} />;
  }
}

export default GroupLink;
